import React from 'react';
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const ErrorPage: React.FC<{}> = () => {
    const routeError = useRouteError();



    if (routeError) {
        // Handle the route error
        console.error('Route Error:', routeError);
        // You can redirect to an error page or take other actions here.
    }

    let output = <></>
    if (isRouteErrorResponse(routeError)) {
        if (routeError.status === 404) {
            output = <div>This page doesn't exist!</div>;
        }

        if (routeError.status === 401) {
            output = <div>You aren't authorized to see this</div>;
        }

        if (routeError.status === 503) {
            output = <div>Looks like our API is down</div>;
        }

        if (routeError.status === 418) {
            output = <div>🫖</div>;
        }
    }

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                {/* <i>{error?.statusText || error?.message}</i> */}
            </p>
            {output}
        </div>
    );
}

export default ErrorPage;